<template>
  <v-card>
    <v-card-title class="headline colorHeadlineStandard" primary-title>
      {{ $tc('label.visitor') }}
      <v-spacer />
      <v-icon large @click="((visitors = []), $emit('update:openDialog', false))">{{ mdiClose }}</v-icon>
    </v-card-title>
    <v-card-text>
      <v-sheet style="overflow-y: auto; overflow-x: hidden" :height="$store.state.windowSize.y - 150" :max-height="580">
        <v-form ref="formPlanVisit" v-model="validVisit">
          <v-row class="my-0 py-0">
            <v-col v-if="listEmployees.length > 0" cols="6">
              <v-combobox
                v-model="selectedEmployee"
                :label="$t('label.visiting')"
                maxlength="128"
                :items="listEmployees"
                item-text="comboBoxName"
                item-value="id"
                auto-select-first
                append-icon
                hide-details
                v-on:change="(listVisitorsLoad(), listApproversLoad(), listAreasLoad())"
                autocomplete="off"
                :disabled="visitors.length > 0"
              />
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="visitor"
                :label="$t('label.appendFromMyVisits')"
                maxlength="128"
                :items="listVisitors"
                item-text="comboBoxName"
                item-value="id"
                :loading="visitorsLoader"
                append-icon
                hide-details
                return-object
                clearable
                v-on:change="processAutocomplete"
                autocomplete="off"
              />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6">
              <v-text-field :label="$t('label.name')" :rules="[ruleRequired]" v-model="visitor.name" maxlength="128" hide-details dense />
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$t('label.surname')"
                :rules="[ruleRequired]"
                v-model="visitor.surname"
                maxlength="128"
                hide-details
                dense
              />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6">
              <v-select
                v-model="visitor.areaid"
                :label="$tc('label.area')"
                :items="listAreas"
                item-text="name"
                item-value="id"
                hide-details
                dense
                :disabled="visitors.length > 0"
              />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="4">
              <v-text-field
                :label="$t('label.documentno')"
                v-model="visitor.documentno"
                v-bind:rules="strictMode ? [ruleRequired] : []"
                hide-details
                dense
              />
            </v-col>
            <v-col class="my-0" cols="4">
              <v-autocomplete
                v-model="visitor.documenttype"
                :label="$tc('label.documentType')"
                maxlength="20"
                :items="listDocumentTypes"
                item-text="comboBoxName"
                item-value="type"
                auto-select-first
                append-icon
                v-bind:rules="strictMode ? [ruleRequired] : []"
                hide-details
                dense
                autocomplete="off"
              />
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                ref="comboCountry"
                v-model="visitor.country"
                :label="$tc('label.country')"
                height="25"
                maxlength="50"
                :items="listCountries"
                item-text="comboBoxName"
                item-value="A3"
                append-icon
                auto-select-first
                v-bind:rules="strictMode ? [ruleRequired] : []"
                hide-details
                dense
                autocomplete="off"
              />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6">
              <v-text-field :label="$t('label.phone')" v-model="visitor.phone" maxlength="64" hide-details dense />
            </v-col>
            <v-col cols="6">
              <v-text-field :label="$t('label.email')" v-model="visitor.email" maxlength="256" hide-details dense />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="6">
              <v-autocomplete
                v-model="visitor.carid"
                :label="$tc('label.car')"
                maxlength="128"
                :items="listCars"
                item-text="plate"
                item-value="id"
                :append-icon="mdiPlusCircle"
                @click:append="dialogCreateCar = true"
                hide-details
                dense
                clearable
                autocomplete="off"
              />
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="visitor.companyid"
                :label="$tc('label.company')"
                maxlength="128"
                :items="listCompanies"
                item-text="name"
                item-value="id"
                :append-icon="mdiPlusCircle"
                @click:append="dialogCreateCompany = true"
                hide-details
                dense
                clearable
                autocomplete="off"
              />
            </v-col>
          </v-row>
          <v-row v-if="listApprovers.length > 0" class="my-0">
            <v-col>
              <v-autocomplete
                v-model="selectedApprovers"
                :label="$t('label.visitApprover')"
                :items="listApprovers"
                item-text="comboBoxName"
                item-value="id"
                :menu-props="{ minWidth: '500' }"
                :return-object="false"
                :rules="[ruleRequiredArray]"
                multiple
                small-chips
                deletable-chips
                append-icon="$dropdown"
                hide-details
                :disabled="sumState.edit"
                dense
              />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col>
              <v-text-field v-model="visitor.note" :label="$tc('label.note')" hide-details dense />
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="3" class="pt-4">
              <b>{{ $t('label.arrival') }}</b>
            </v-col>
            <v-col cols="3">
              <v-menu
                v-model="dateEnterMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                :disabled="visitors.length > 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateEnterFormatted"
                    :label="$t('label.date')"
                    @blur="dateEnter = momentParse(dateEnterFormatted)"
                    :rules="[ruleValidDate, dateGreaterThanNow]"
                    dense
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    autocomplete="off"
                    :disabled="
                      visitors.length > 0 ||
                      (sumState.plannedVisitSelected.groupMembers !== undefined && sumState.plannedVisitSelected.groupMembers.length > 1)
                    "
                  />
                </template>
                <v-date-picker
                  :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
                  v-model="dateEnter"
                  :min="new Date().toISOString()"
                  scrollable
                  no-title
                  @input="dateEnterMenu = false"
                  :disabled="visitors.length > 0"
                />
              </v-menu>
            </v-col>

            <v-col cols="3">
              <vue-timepicker
                v-model="timeEnter"
                input-width="100%"
                hide-clear-button
                :minute-interval="5"
                drop-direction="up"
                advanced-keyboard
                auto-scroll
                manual-input
                :disabled="
                  visitors.length > 0 ||
                  (sumState.plannedVisitSelected.groupMembers !== undefined && sumState.plannedVisitSelected.groupMembers.length > 1)
                "
                @change="timeEnterChange"
              />
            </v-col>
            <v-col cols="3">
              <vue-timepicker
                v-model="timeExit"
                input-width="100%"
                hide-clear-button
                :minute-interval="5"
                :hourRange="exitHoursMin()"
                :minuteRange="exitMinutesMin()"
                drop-direction="up"
                advanced-keyboard
                auto-scroll
                manual-input
                @close="timeEnter >= timeExit ? [(timeExit = timeEnter)] : []"
                :disabled="
                  visitors.length > 0 ||
                  (sumState.plannedVisitSelected.groupMembers !== undefined && sumState.plannedVisitSelected.groupMembers.length > 1)
                "
              />
            </v-col>
          </v-row>
          <v-row v-if="!sumState.edit" class="my-0">
            <v-col cols="3" class="pt-4">
              <b>{{ $t('label.arrivalRepeat') }}</b>
            </v-col>
            <v-col cols="9" @click="visitors.length == 0 ? (additionalDatesMenu = true) : []">
              <v-menu
                ref="additionalDatesMenu"
                v-model="additionalDatesMenu"
                :close-on-content-click="false"
                :return-value.sync="additionalDates"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-combobox
                    v-model="additionalDatesFormatted"
                    :label="$t('label.date')"
                    multiple
                    chips
                    small-chips
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    autocomplete="off"
                    :disabled="visitors.length > 0"
                  />
                </template>
                <v-date-picker
                  :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
                  multiple
                  v-model="additionalDates"
                  :min="momentAddDay()"
                  scrollable
                  no-title
                  :disabled="visitors.length > 0"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="additionalDatesMenu = false"> {{ $t('btn.cancel') }} </v-btn>
                  <v-btn text color="primary" @click="$refs.additionalDatesMenu.save(additionalDates)"> {{ $t('btn.save') }} </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-sheet>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-btn v-if="visitor.id > 0" @click="dialogDelete = true" color="colorDelete">{{ $t('btn.delete') }}</v-btn>
      <v-btn v-if="!sumState.edit" @click="appendVisitors" color="colorSave">{{ $t('btn.addToGroup') }}</v-btn>
      <v-btn v-if="visitors.length > 0" @click="dialogGroupVisits = true" color="colorEdit">
        {{ $t('btn.visitorsGroupList') }} ({{ visitors.length }})
      </v-btn>
      <v-spacer />
      <v-btn v-if="listAreas.length > 0" @click="actionSave" color="colorSave">{{ $t('btn.save') }}</v-btn>
    </v-card-actions>
    <!-----DIALOGS-------------------------------->
    <v-dialog v-model="dialogCreateCar" persistent max-width="60%">
      <carEdit v-on:closeDialog="dialogCreateCar = false" v-on:newCarID="listCarsLoad" />
    </v-dialog>
    <v-dialog v-model="dialogCreateCompany" persistent max-width="60%">
      <companyEdit v-on:closeDialog="dialogCreateCompany = false" v-on:newCompanyID="listCompaniesLoad" />
    </v-dialog>
    <v-dialog v-model="dialogGroupVisits" max-width="80%">
      <v-card-title class="headline colorHeadlineStandard" primary-title>
        {{ $tc('label.visitor', 2) }}
        <v-spacer />
        <v-icon large @click="dialogGroupVisits = false">{{ mdiClose }}</v-icon>
      </v-card-title>
      <v-sheet style="overflow-y: auto; overflow-x: hidden" :height="$store.state.windowSize.y - 150" :max-height="580">
        <v-card-text>
          <v-row class="brown lighten-2">
            <v-col cols="3">
              <h2>{{ $t('label.name') }}</h2>
            </v-col>
            <v-col cols="3">
              <h2>{{ $t('label.surname') }}</h2>
            </v-col>
            <v-col cols="3">
              <h2>{{ $t('label.documentno') }}</h2>
            </v-col>
            <v-col cols="2" />
            <v-col cols="1">
              <h3>{{ $t('btn.delete') }}</h3>
            </v-col>
          </v-row>

          <div v-for="(visit, index) in visitors" :key="index">
            <v-row :class="index % 2 ? 'brown lighten-5' : 'brown lighten-4'">
              <v-col cols="3">
                <h2>{{ visit.name }}</h2>
              </v-col>
              <v-col cols="3">
                <h2>{{ visit.surname }}</h2>
              </v-col>
              <v-col cols="3">
                <h2>{{ visit.documentno }}</h2>
              </v-col>
              <v-col cols="2" />
              <v-col cols="1">
                <v-btn icon @click="removeFromVisitorsArray(index)">
                  <v-icon color="red">{{ mdiDelete }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-sheet>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      ::body="`${$t('msg.confirmDelete')}?`"
      :openDialog.sync="dialogDelete"
      v-on:confirm="plannedVisitsDelete"
    />
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import moment from 'moment-timezone';
import carEdit from '../dataEdit/car.vue';
import companyEdit from '../dataEdit/company.vue';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiPlusCircle, mdiClose, mdiDelete } from '@mdi/js';

export default Vue.extend({
  name: 'PlanVisit',
  components: { VueTimepicker, carEdit, companyEdit, DialogConfirmDelete },
  props: {
    sumState: Object,
    openDialog: Boolean,
  },
  data: () => ({
    dialogCreateCar: false,
    dialogCreateCompany: false,
    dialogGroupVisits: false,
    dialogDelete: false,
    dateEnter: '',
    dateEnterFormatted: '',
    dateEnterMenu: false,
    timeEnter: '',
    timeExit: '',
    listAreas: [],
    listApprovers: [],
    listCars: [],
    listCompanies: [],
    listCountries: [],
    listDocumentTypes: [],
    listVisitors: [
      {
        approvers: [],
      },
    ],
    listEmployees: [
      {
        id: 0,
        employeeid: 0,
        comboBoxName: 0,
        employeeGroup: 0,
        area: 0,
      },
    ],
    selectedEmployee: {
      id: 0,
      area: 0,
      employeeGroup: 0,
    },
    strictMode: false, // Vyzadovat povinne Typ, Stat, Doklad
    visitor: {
      id: 0,
      employeeid: 0,
      name: '',
      surname: '',
      documentno: '',
      documenttype: '',
      country: '',
      phone: '',
      email: '',
      carid: 0,
      companyid: 0,
      areaid: 0,
      timearrive: '',
      timedeparture: '',
      approvers: [] as number[],
      note: '',
    },
    selectedApprovers: [],
    visitors: [],
    additionalDates: [], // Pole pre opakovane navstevy datumy
    additionalDatesFormatted: [], // formatovany cas pre zobrazenie v selecte
    additionalDatesMenu: false,
    visitorsArea: 0, // Ak ide o skupinove planovanie poznaci zvolenu area
    visitorsLoader: false,
    validVisit: false,
    mdiPlusCircle: mdiPlusCircle,
    mdiClose: mdiClose,
    mdiDelete: mdiDelete,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleRequiredArray() {
      return (v: any) => v.length > 0 || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleValidDate() {
      return (v: any) => this.$moment(v, this.$store.state.auth.df.date, true).isValid() || this.$i18n.t('msg.invalidDateFormat');
    },
    dateGreaterThanNow() {
      return () =>
        this.$moment(new Date()).subtract(1, 'days').toDate() < new Date(this.dateEnter) || this.$i18n.t('msg.arrivalCannotBeInPast');
    },
  },
  watch: {
    selectedApprovers() {
      if (this.visitors.length > 0) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.approversUpdated'));
      }
    },
    additionalDates() {
      this.additionalDatesFormatted = [];
      for (const date of this.additionalDates) {
        if (this.$moment(date, 'YYYY-MM-DD', true).isValid()) {
          this.additionalDatesFormatted.push(this.$moment(date, 'YYYY-MM-DD').format(this.$store.state.auth.df.date));
        }
      }
    },
    async openDialog() {
      if (this.openDialog) {
        this.additionalDates = [];
        if (this.sumState.edit) {
          const plannedEmployee = this.listEmployees
            .map((item: any) => {
              return item.id;
            })
            .indexOf(this.sumState.plannedVisitSelected.employeeid);
          if (plannedEmployee === -1) {
            this.selectedEmployee = this.listEmployees[0]; // TODO - vyriesit lepsie
          } else {
            this.selectedEmployee = this.listEmployees[plannedEmployee];
          }
          this.visitor = { ...this.sumState.plannedVisitSelected };
          this.selectedApprovers = this.visitor.approvers;
          const tz = this.sumState.plannedVisitSelected.timezone;
          this.dateEnter = moment(this.sumState.plannedVisitSelected.timearrive, '').tz(tz).format('YYYY-MM-DD');
          this.timeEnter = moment(this.sumState.plannedVisitSelected.timearrive, '').tz(tz).format('HH:mm');
          this.timeExit = moment(this.sumState.plannedVisitSelected.timedeparture, '').tz(tz).format('HH:mm');
        } else {
          const defaults: any = this.$options;
          this.visitor = { ...defaults.data().visitor };
          this.visitor.areaid = this.$store.state.auth.employeeSettings.area;
          this.dateEnter = this.sumState.calValue;
          if (this.listEmployees.length > 0) {
            this.selectedEmployee = this.listEmployees[0];
          }
          await this.listApproversLoad();
          let timeNow = this.$moment(Date.now());
          this.timeEnter = this.$moment(timeNow)
            .add(15 - (timeNow.minute() % 15), 'minutes')
            .format('HH:mm');
          const form: any = this.$refs.formPlanVisit;
          form.validate();
        }
      }
    },
    dateEnter() {
      if (this.dateEnter < this.$moment(new Date()).format('YYYY-MM-DD') && this.openDialog) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.arrivalCannotBeInPast'));
        // this.dateEnter = this.$moment(new Date()).format('YYYY-MM-DD');
      }
      this.$nextTick(() => {
        var date: string = this.$moment(this.dateEnter).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.dateEnterFormatted = date;
        } else {
          // this.$store.commit('globalMessage', 'Špatně zadaný datum expirace !!!');
          this.dateEnter = '';
          this.dateEnterFormatted = '';
        }
        const form: any = this.$refs.formPlanVisit;
        form.validate();
      });
    },
    'visitor.areaid'() {
      this.checkStrictMode();
    },
  },
  async mounted() {
    this.visitor.areaid = this.$store.state.auth.employeeSettings.area;
    await this.listVisitorsLoad();
    await this.listDocumentTypesLoad();
    await this.listCountriesLoad();
    await this.listEmployeesLoad().then(() => {
      if (this.sumState.edit && this.openDialog) {
        const plannedEmployee = this.listEmployees
          .map((item: any) => {
            return item.id;
          })
          .indexOf(this.sumState.plannedVisitSelected.employeeid);
        if (plannedEmployee === -1) {
          this.selectedEmployee = this.listEmployees[0]; // TODO - vyriesit lepsie
        } else {
          this.selectedEmployee = this.listEmployees[plannedEmployee];
        }
      }
    });
    await this.listCarsLoad(0);
    await this.listCompaniesLoad(0);
    await this.listAreasLoad().then(() => {
      this.checkStrictMode();
    });
    let timeNow = this.$moment(Date.now());
    this.timeEnter = this.$moment(timeNow)
      .add(15 - (timeNow.minute() % 15), 'minutes')
      .format('HH:mm');
    this.timeExit = this.$moment(timeNow)
      .add(15 - (timeNow.minute() % 15) + 60, 'minutes')
      .format('HH:mm');
    this.dateEnter = this.sumState.calValue;
    if (this.sumState.edit && this.openDialog) {
      this.visitor = { ...this.sumState.plannedVisitSelected };
      const tz = this.sumState.plannedVisitSelected.timezone;
      this.dateEnter = moment(this.sumState.plannedVisitSelected.timearrive, '').tz(tz).format('YYYY-MM-DD');
      this.timeEnter = moment(this.sumState.plannedVisitSelected.timearrive, '').tz(tz).format('HH:mm');
      this.timeExit = moment(this.sumState.plannedVisitSelected.timedeparture, '').tz(tz).format('HH:mm');
    }
    this.listApproversLoad().then(() => {
      // Validate az po vytvoreni listboxu approverov
      this.sumState.edit ? (this.selectedApprovers = this.visitor.approvers) : {};
      const form: any = this.$refs.formPlanVisit;
      form.validate();
    });
  },
  methods: {
    removeFromVisitorsArray(index: number) {
      this.visitors.splice(index, 1);
    },
    appendVisitors() {
      // Skontroluj formular
      const form: any = this.$refs.formPlanVisit;
      if (!form.validate()) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
        return;
      }

      if (this.listEmployees.length > 0) {
        this.visitor.employeeid = this.selectedEmployee.id;
      }
      if (
        this.$moment(this.$moment(this.dateEnter + ' ' + this.timeEnter, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')).isBefore(
          this.$moment(Date.now()),
        )
      ) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.arrivalCannotBeInPast'));
        return;
      }
      this.visitor.timearrive = this.$moment(this.dateEnter + '_' + this.timeEnter, 'YYYY-MM-DD_HH:mm')
        .utcOffset(0, true)
        .format();
      this.visitor.timedeparture = this.$moment(this.dateEnter + '_' + this.timeExit, 'YYYY-MM-DD_HH:mm')
        .utcOffset(0, true)
        .format();
      this.visitors.push({ ...this.visitor });
      this.visitor.name = '';
      this.visitor.surname = '';
      this.visitor.documentno = '';
      this.visitor.documenttype = '';
      this.visitor.country = '';
      this.visitor.phone = '';
      this.visitor.email = '';
      this.visitorsArea = this.visitor.areaid;
    },
    actionSave() {
      // Pokial uz su zadane navstevy v groupe, tak uloz co je
      if (this.visitors.length > 0 && this.visitor.name === '' && this.visitor.surname === '' && this.visitor.documentno === '') {
        this.plannedVisitsPost();
        return;
      }
      // Skontroluj formular
      const form: any = this.$refs.formPlanVisit;
      if (!form.validate()) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
        return;
      }
      // Editace
      if (this.sumState.edit) {
        this.visitor.timearrive = this.$moment(this.dateEnter + '_' + this.timeEnter, 'YYYY-MM-DD_HH:mm')
          .utcOffset(0, true)
          .format();
        this.visitor.timedeparture = this.$moment(this.dateEnter + '_' + this.timeExit, 'YYYY-MM-DD_HH:mm')
          .utcOffset(0, true)
          .format();
        this.plannedVisitsPut();
        return;
      }
      this.appendVisitors();
      this.plannedVisitsPost();
    },
    momentParse(inputDate: string) {
      return this.$moment(inputDate, this.$store.state.auth.df.date, true).isValid()
        ? this.$moment(inputDate, this.$store.state.auth.df.date).format('YYYY-MM-DD')
        : '';
    },
    momentAddDay() {
      if (this.dateEnter === '') {
        return this.$moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
      }
      return this.$moment(this.dateEnter).add(1, 'days').format('YYYY-MM-DD');
    },
    listVisitorsLoad() {
      if (this.selectedEmployee.id !== 0) {
        this.visitor.areaid = this.selectedEmployee.area;
      }
      this.visitorsLoader = true;
      axios
        .get(`/api/v1/employeeview/uniquevisits/${this.selectedEmployee.id}`)
        .then((response) => {
          for (const visitor of response.data) {
            visitor.comboBoxName = visitor.name + ' ' + visitor.surname + ', ' + visitor.documenttype;
            visitor.areaid = this.$store.state.auth.employeeSettings.area;
          }
          this.listVisitors = response.data;
          this.visitorsLoader = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
          this.visitorsLoader = false;
        });
    },
    async listApproversLoad() {
      await axios
        .get(`/api/v1/employeeview/approvers/${this.selectedEmployee.employeeGroup}`)
        .then((response) => {
          for (const employee of response.data.approvers) {
            employee.comboBoxName = employee.surname + ' ' + employee.name;
            if (employee.department != '') {
              employee.comboBoxName = employee.comboBoxName + ' (' + employee.department + ')';
            }
          }
          this.selectedApprovers = [];
          if (response.data.notify) {
            for (const employee of response.data.approvers) {
              this.selectedApprovers.push(employee.id);
            }
          }
          this.listApprovers = response.data.approvers;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async listDocumentTypesLoad() {
      this.listDocumentTypes = [];
      await axios
        .get('/api/v1/documenttype')
        .then((response) => {
          for (const docType of response.data) {
            docType.comboBoxName = docType.type + ' - ' + docType.name;
          }
          this.listDocumentTypes = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async listCountriesLoad() {
      this.listCountries = [];
      await axios
        .get('/api/v1/countries')
        .then((response) => {
          for (const country of response.data) {
            country.comboBoxName = country.A3 + ' - ' + country.czShort;
          }
          this.listCountries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    plannedVisitsPost() {
      // Nastav datumy pre opakovane navstevy
      let additionalDatesDateTime = [];
      if (this.additionalDates.length > 0) {
        for (const date of this.additionalDates) {
          additionalDatesDateTime.push({
            enter: this.$moment(date + '_' + this.timeEnter, 'YYYY-MM-DD_HH:mm')
              .utcOffset(0, true)
              .format(),
            exit: this.$moment(date + '_' + this.timeExit, 'YYYY-MM-DD_HH:mm')
              .utcOffset(0, true)
              .format(),
          });
        }
      }
      // Nastav approvers pre vsetky navstevy v skupine
      for (const visitor of this.visitors) {
        visitor.approvers = this.selectedApprovers;
      }
      axios
        .post(`/api/v1/plannedvisit`, { visitors: this.visitors, additionalDates: additionalDatesDateTime })
        .then(() => {
          this.$emit('update:openDialog', false);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        })
        .finally(() => {
          this.visitors = [];
        });
    },
    plannedVisitsPut() {
      axios
        .put(`/api/v1/plannedvisit`, this.visitor)
        .then(() => {
          this.$emit('update:openDialog', false);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    plannedVisitsDelete() {
      axios
        .delete(`/api/v1/plannedvisit/${this.sumState.plannedVisitSelected.id}/${this.sumState.plannedVisitSelected.pvuid}`, {
          timeout: 1000 * 5,
        })
        .then(() => {
          this.$emit('update:openDialog', false);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async listEmployeesLoad() {
      await axios
        .get(`/api/v1/employeebyplanner`)
        .then((response) => {
          for (const employee of response.data) {
            employee.comboBoxName = employee.surname + ' ' + employee.name;
            let x = [];
            employee.department ? x.push(this.$i18n.tc('label.department') + ': ' + employee.department) : {};
            employee.phone ? x.push(this.$i18n.tc('label.phone') + ': ' + employee.phone) : {};
            employee.mobile ? x.push(this.$i18n.tc('label.mobile') + ': ' + employee.mobile) : {};
            employee.comboBoxName += x.length > 0 ? ' (' + x.join(' / ') + ')' : '';
          }
          this.listEmployees = response.data;
          if (this.listEmployees.length > 0) {
            let myEmployee: any = { id: 0, comboBoxName: this.$i18n.t('label.myVisit'), employeeGroup: 0 };
            this.listEmployees.unshift(myEmployee);
            this.selectedEmployee = this.listEmployees[0];
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async listCarsLoad(newCarID: number) {
      await axios
        .get(`/api/v1/car`)
        .then((response) => {
          this.listCars = response.data;
          this.visitor.carid = newCarID;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async listCompaniesLoad(newCompanyID: number) {
      await axios
        .get('/api/v1/company')
        .then((response) => {
          this.listCompanies = response.data;
          this.visitor.companyid = newCompanyID;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    async listAreasLoad() {
      await axios
        .get(`/api/v1/areasbyemployee/${this.selectedEmployee.id}`)
        .then((response) => {
          this.listAreas = response.data;
          this.listAreas.length > 0 ? (this.visitor.areaid = this.listAreas[0].id) : {};
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    processAutocomplete(value: any) {
      // Pri mazani Xkom values undefined takze vyskoc
      if (value === null) {
        const defaults: any = this.$options;
        this.visitor = { ...defaults.data().visitor };
        this.visitor.areaid = this.$store.state.auth.employeeSettings.area;
        return;
      }
      // Ak ide o skupinove planovanie drz jednu areu
      this.visitors.length > 0 ? (this.visitor.areaid = this.visitorsArea) : {};
    },
    checkStrictMode() {
      this.strictMode = false;
      for (const area of this.listAreas) {
        if (area.id === this.visitor.areaid && area.planningStrict) {
          this.strictMode = true;
          break;
        }
      }
    },
    timeEnterChange() {
      if (this.$moment(this.timeEnter, 'HH:mm').add(60, 'minutes').format('DD') === this.$moment(this.timeEnter, 'HH:mm').format('DD')) {
        this.timeExit = this.$moment(this.timeEnter, 'HH:mm').add(60, 'minutes').format('HH:mm');
      } else {
        this.timeExit = this.$moment(this.timeEnter, 'HH:mm').format('HH:mm');
      }
    },
    exitHoursMin() {
      const currentHH = this.$moment(this.timeEnter, 'HH:mm').format('HH');
      const range = [];
      for (let i = parseInt(currentHH, 10); i <= 23; i++) {
        range.push(i);
      }
      return range;
    },
    exitMinutesMin() {
      const currentMM = this.$moment(this.timeEnter, 'HH:mm').format('mm');
      let startMM = 0;
      if (this.$moment(this.timeEnter, 'HH:mm').format('HH') === this.$moment(this.timeExit, 'HH:mm').format('HH')) {
        startMM = parseInt(currentMM, 10) + 5;
        if (this.$moment(this.timeExit, 'HH:mm').diff(this.$moment(this.timeEnter, 'HH:mm'), 'minutes') < 5) {
          this.timeExit = this.$moment(this.timeEnter, 'HH:mm').add(5, 'minutes').format('HH:mm');
        }
      } else {
        startMM = 0;
      }
      const range = [] as number[];
      for (let i = startMM; i <= 55; i += 5) {
        range.push(i);
      }
      return range;
    },
  },
});
</script>
